import React from 'react';
import {Checkbox} from 'antd';
const CheckboxGroup = Checkbox.Group;
import {WeaSearchGroup, WeaFormItem} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';
//import EField from './base/EField';
import EField_New from './base/EField_New'

// 计划任务
export default class Content_32 extends React.Component {
    state = {
        ePlanCreator: this.props.ePlanCreator.checked,
        eUserRole: this.props.eUserRole.checked,
        ePlanState: this.props.ePlanState.checked,
        ePlanType: this.props.ePlanType.checked,
        eFieldNewDataSource: this.props.eFieldNewDataSource,
        eFieldNewUsedKeys: this.props.eFieldNewUsedKeys,
        eFieldNewVisible: false,
    };

    render() {
        const {ePlanCreator, eUserRole, ePlanState, ePlanType, eFieldNewDataSource, eFieldNewUsedKeys, eFieldNewVisible} = this.state;

        let EPlanCreator = <div></div>;
        let EUserRole = <div></div>;
        let EPlanState = <div></div>;
        let EPlanType = <div></div>;
        if (this.props.eShareLevel == '2') {
            EPlanCreator = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@3xz363`} label={getLabel(22319, '计划任务创建人')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <CheckboxGroup ecId={`${this && this.props && this.props.ecId || ''}_CheckboxGroup@nl8cda`} size="default" options={this.props.ePlanCreator.options} value={ePlanCreator} onChange={checkedValue => this.setState({ePlanCreator: checkedValue})}/>
                </WeaFormItem>
            );
            EUserRole = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@h9rhwu`} label={getLabel(22320, '用户扮演角色')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <CheckboxGroup ecId={`${this && this.props && this.props.ecId || ''}_CheckboxGroup@el2s1c`} size="default" options={this.props.eUserRole.options} value={eUserRole} onChange={checkedValue => this.setState({eUserRole: checkedValue})}/>
                </WeaFormItem>
            );
            EPlanState = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@wm6jax`} label={getLabel(21947, '计划任务状态')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <CheckboxGroup ecId={`${this && this.props && this.props.ecId || ''}_CheckboxGroup@whibs8`} size="default" options={this.props.ePlanState.options} value={ePlanState} onChange={checkedValue => this.setState({ePlanState: checkedValue})}/>
                </WeaFormItem>
            );
            EPlanType = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@7sabyz`} label={getLabel(22321, '计划任务类型')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <div className="portal-esetting-checkbox-group">
                        <CheckboxGroup ecId={`${this && this.props && this.props.ecId || ''}_CheckboxGroup@zfrgi4`} size="default" options={this.props.ePlanType.options} value={ePlanType} onChange={checkedValue => this.setState({ePlanType: checkedValue})}/>
                    </div>
                </WeaFormItem>
            );
        }

        let EFieldNewshow = <div></div>;
        let EFieldNew = <div></div>;
        if (eFieldNewVisible) {
            const eFieldNewProps = {
                eFieldNewDataSource: _.cloneDeep(eFieldNewDataSource),
                eFieldNewUsedKeys: _.cloneDeep(eFieldNewUsedKeys),
                onOk: (data) => {
                    this.setState({
                        eFieldNewDataSource: _.cloneDeep(data.eFieldNewDataSource),
                        eFieldNewUsedKeys: _.cloneDeep(data.eFieldNewUsedKeys),
                        eFieldNewVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        eFieldNewVisible: false
                    });
                }
            };
            EFieldNewshow = (
                <EField_New ecId={`${this && this.props && this.props.ecId || ''}_EField_New@lrebqe`} {...eFieldNewProps}/>
            );
        }
        const eFieldNewUsedNames = [];
        for (let i = 0; i < eFieldNewUsedKeys.length; i++) {
            for (let j = 0 ; j < eFieldNewDataSource.length; j++) {
                if (eFieldNewUsedKeys[i] == eFieldNewDataSource[j].key) {
                    eFieldNewUsedNames.push(eFieldNewDataSource[j].name);
                }
            }
        }
        
        EFieldNew = this.props.eShareLevel == '2' ? (
            <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@a1ww92`} label={getLabel(19495, '显示字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                {EFieldNewshow}
                <div style={{height: '30px', lineHeight: '23px'}}>
                    <i className="icon-coms-Flow-setting portal-esetting-btn" onClick={() => this.setState({eFieldNewVisible: true})}/>
                    <span>{eFieldNewUsedNames.join('，')}</span>
                </div>
            </WeaFormItem>
        ) : '';

        return (
            <div>
                <WeaSearchGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSearchGroup@boifr8`} title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ecId={`${this && this.props && this.props.ecId || ''}_EType@oroc29`} ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ecId={`${this && this.props && this.props.ecId || ''}_ETitle@41axug`} ref="eTitle" eid={this.props.eid} value={this.props.eTitle}  {...this.props}/> : ''}
                    <EShowNum ecId={`${this && this.props && this.props.ecId || ''}_EShowNum@leg7ef`} ref="eShowNum" value={this.props.eShowNum}/>
                    <ELinkMode ecId={`${this && this.props && this.props.ecId || ''}_ELinkMode@acznfs`} ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                    {/*<EField ref="eField" value={this.props.eField}/>*/}
                    {EFieldNew}
                    {EPlanCreator}
                    {EUserRole}
                    {EPlanState}
                    {EPlanType}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentFieldNewUsedKeys: this.state.eFieldNewUsedKeys,
            eContentPlanCreator: this.state.ePlanCreator,
            eContentUserRole: this.state.eUserRole,
            eContentPlanState: this.state.ePlanState,
            eContentPlanType: this.state.ePlanType
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_32.js